<template>
  <div>
    <TableAudit
      :table-title="'Pending'"
      :api-url-props="APIURL"
      :columns="columns"
      :top-header="topHeader"
    />
  </div>
</template>

<script>
import TableAudit from './TableAudit.vue'

export default {
  components: { TableAudit },
  data() {
    return {
      APIURL: 'audit/pending',
      columns: [
        // audit details
        { key: 'audit_date', label: 'Audit Date' },
        { key: 'description', label: 'Description' },
        { key: 'grant_procedure_number', label: 'Gant Procedure Number' },
        { key: 'days_require', label: 'Days Require' },
        { key: 'license_expiry_date', label: 'License Expiry Date' },
        { key: 'previous_audit_date', label: 'Previous Audit Date' },
        { key: 'location', label: 'Location' },
        { key: 'status', label: 'status' },
        // company details
        { key: 'company_email', label: 'Company Email' },
        { key: 'company_name', label: 'Company Name' },
        { key: 'country', label: 'Country' },
        // auditor details
        { key: 'previous_auditor.name', label: 'name' },
        { key: 'previous_auditor.email', label: 'email' },
        { key: 'previous_auditor.phone', label: 'phone' },
        // requester details
        { key: 'requester.name', label: 'name' },
        { key: 'requester.email', label: 'email' },
        { key: 'requester.phone', label: 'phone' },
        // request details
        { key: 'request.request_code', label: 'Request Code' },
        { key: 'request_engineers', label: 'Engineers Assigned' },
        { key: 'request_certificate', label: 'Main Certificate' },
        { key: 'request_sub_certificate', label: 'Sub Certificate' },
        // request attachments
        { key: 'attachments_audit', label: '' },

        // actions
        { key: 'return_to_ce', label: 'Return to CE' },
        { key: 'assign_date_engineer', label: 'Assign Date and Engineer' },
        { key: 'actions' },
      ],
      topHeader: [
        { lable: 'Audit Details', colspan: 9 },
        { lable: 'Company Details', colspan: 3 },
        { lable: 'Auditor Details', colspan: 3 },
        { lable: 'CE Details', colspan: 3 },
        { lable: 'Request Details', colspan: 4 },
        { lable: 'Attachments', colspan: 1 },
        { lable: 'Action', colspan: 3 },
      ],
    }
  },
}
</script>
